// extracted by mini-css-extract-plugin
export default {"flexCenter":"style_flexCenter__PokJW","titleStyle":"style_titleStyle__Uxu-a","boldTitleStyle":"style_boldTitleStyle__DFn2p","dateText":"style_dateText__gsFkD"};